import React from 'react'

import { PlatformUtil } from '@root/shared'
import { Separator } from '@root/shared/ui-kit'

import type { Options, Components as Components_ } from 'react-markdown'

const Markdown_ = React.lazy(() => import('react-markdown'))

export interface MarkdownProps extends Options {
  fallback: React.ReactNode
}
export const Markdown = (props: MarkdownProps) => {
  const { fallback, components, ...mdProps } = props

  const components_ = {
    ...MarkdownComponents,
    ...components,
  }
  return (
    <React.Suspense fallback={fallback}>
      <Markdown_ components={components_} {...mdProps} />
    </React.Suspense>
  )
}

const MarkdownComponents = {
  a: (props) => (
    <LinkTargetBlank
      {...props}
      onClick={(e) => {
        if (PlatformUtil.is('tauri')) {
          e.preventDefault()
          if (props.href) {
            PlatformUtil.openLink(props.href)
          }
        }
      }}
    />
  ),
  hr: () => <Separator />,
} satisfies Markdown.Components

export const LinkTargetBlank = (
  props: React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  >,
) => <a {...props} target="_blank" />

// eslint-disable-next-line @typescript-eslint/no-redeclare
export declare namespace Markdown {
  export type Components = Components_
}
